import { theme } from 'aimo-ui';
import InfoBox from 'components/common/InfoBox';
import Icon from 'components/icons/Icon';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components/native';
import { Maybe, Pmc } from 'types/generatedSchemaTypes';
import { isPmcAvailable } from 'utils/permitUtils';

const Container = styled.View`
  justify-content: center;
  align-items: flex-end;
  flex-shrink: 0;
  align-self: center;
`;

const Content = ({
  pmc,
  pmcIsLockedForTheCustomer,
  pmcIsInsideALockedMemberGroup,
}: {
  pmc: Maybe<Pmc> | undefined;
  pmcIsLockedForTheCustomer?: boolean;
  pmcIsInsideALockedMemberGroup?: boolean;
}) => {
  const { showWaitingList, permitNotAvailable, amountAvailable } =
    isPmcAvailable(pmc);
  const { t } = useTranslation();

  if (
    (!pmcIsInsideALockedMemberGroup && pmc?.visibility === 'LOCKED') ||
    pmcIsLockedForTheCustomer
  ) {
    return (
      <Icon
        name="Locked-Filled"
        color={theme.colors.black}
        testID="locked-icon"
        size="s"
      />
    );
  }
  if (showWaitingList) {
    return (
      <InfoBox
        textCenter
        margin={0}
        bgColor={theme.colors.white}
        padding={7}
        text={t('longTermParking.waitingList.list')}
        textColor={theme.colors.primary}
      />
    );
  }
  if (permitNotAvailable) {
    return (
      <InfoBox
        textCenter
        margin={0}
        bgColor={theme.colors.white}
        padding={7}
        text={'0'}
        textColor={theme.colors.aimoUiRed}
      />
    );
  }
  if (
    pmcIsInsideALockedMemberGroup &&
    !pmcIsLockedForTheCustomer &&
    pmc?.reservationType === 'NON_RESERVED'
  ) {
    return (
      <Icon
        name="Unlocked-Filled"
        color={theme.colors.black}
        testID="unlocked-icon"
        size="s"
      />
    );
  }
  if (amountAvailable === 9999) {
    return null;
  }
  return (
    <InfoBox
      textCenter
      margin={0}
      bgColor={theme.colors.white}
      padding={7}
      text={amountAvailable.toString()}
      textColor={theme.colors.primary}
    />
  );
};

const PermitAvailability = ({
  pmc,
  pmcIsLockedForTheCustomer,
  pmcIsInsideALockedMemberGroup,
}: {
  pmc: Maybe<Pmc> | undefined;
  pmcIsLockedForTheCustomer?: boolean;
  pmcIsInsideALockedMemberGroup?: boolean;
}) => {
  return (
    <Container>
      <Content
        pmc={pmc}
        pmcIsLockedForTheCustomer={pmcIsLockedForTheCustomer}
        pmcIsInsideALockedMemberGroup={pmcIsInsideALockedMemberGroup}
      />
    </Container>
  );
};
export default PermitAvailability;
